// src/services/ApiService.js
const apiService = async ({ method, url, data = null, headers = {}, sessionId = "" }) => {
  const apiHost = process.env.REACT_APP_API_URL || "http://localhost:3000"; // URL ของ API ที่คุณใช้
  const apiKey = process.env.REACT_APP_API_KEY || "cb4b9a44fd024e9e24e1e6e6b2d26720";

  const isFormData = typeof FormData !== "undefined" && data instanceof FormData;

  const defaultHeaders = {
    ...(isFormData ? {} : { "Content-Type": "application/json" }),
    "x-session-id": sessionId, // ส่ง sessionId ใน header
    apikey: apiKey,
    ...headers,
  };

  // ไม่ต้องส่ง Content-Type สำหรับ FormData ปล่อยให้ browser จัดการ boundary ให้เอง
  if (isFormData && defaultHeaders["Content-Type"]) {
    delete defaultHeaders["Content-Type"];
  }

  const requestBody = isFormData ? data : data ? JSON.stringify(data) : null;

  console.log("API Request:", {
    url: `${apiHost}${url}`,
    method,
    headers: defaultHeaders,
    body: isFormData ? "[form-data]" : requestBody,
  });

  try {
    const response = await fetch(`${apiHost}${url}`, {
      method,
      headers: defaultHeaders,
      body: requestBody,
    });

    const text = await response.text();
    console.log("API URL : ", url);
    console.log("Raw Response : ", text);

    let result;
    try {
      result = JSON.parse(text);
    } catch (e) {
      throw new Error("Response is not valid JSON: " + text);
    }

    if (!response.ok) {
      throw new Error(result.error || `API request failed with status ${response.status}`);
    }

    return result;
  } catch (error) {
    console.error("API Error:", error.message);
    throw error;
  }
};

export default apiService;